/* this file is transformed by vux-loader */
/* eslint-disable */
import _createForOfIteratorHelper from "F:/zhaoyanning/\u627F\u5FB7\u5E02\u653F\u5E9C-\u5BF9\u63A5\u94F6\u884C/mobile-master/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.find-index.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Datetime from 'vux/src/components/datetime';
import PopupPicker from 'vux/src/components/popup-picker';
import XButton from 'vux/src/components/x-button';
import XTextarea from 'vux/src/components/x-textarea';
import UploadImageRequired from '@/components/UploadImage/UploadImageRequired';
import atitle from '@/components/Approve/atitle';
import { Dialog, Toast } from 'vant'; // -----审批节点

import FixedNode from '@/components/Approve/FixedNode';
import AssignNode from '@/components/Approve/AssignNode';
import OfficersNode from '@/components/Approve/OfficersNode';
import NoAssiginNode from '@/components/Approve/NoAssiginNode';
import copyOffNode from '@/components/Approve/copyOffNode';
import copyNoAssiginNode from '@/components/Approve/copyNoAssiginNode';
import copyFixedNode from '@/components/Approve/copyFixedNode';
export default {
  name: 'overtimeD',
  components: {
    PopupPicker: PopupPicker,
    Datetime: Datetime,
    XTextarea: XTextarea,
    XButton: XButton,
    UploadImageRequired: UploadImageRequired,
    atitle: atitle,
    FixedNode: FixedNode,
    AssignNode: AssignNode,
    OfficersNode: OfficersNode,
    NoAssiginNode: NoAssiginNode,
    copyOffNode: copyOffNode,
    copyNoAssiginNode: copyNoAssiginNode,
    copyFixedNode: copyFixedNode
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$utils.Store.removeItem('kssj');
    this.$utils.Store.removeItem('jssj');
    this.$utils.Store.removeItem('reason');
    this.$utils.Store.getItem('workType');
    next();
  },
  data: function data() {
    return {
      actions: this.$api.Base.dev + '/management/insertPhoto',
      //上传图片接口
      bh: '00300',
      //假类编号
      workTypeList: [{
        name: '早加班',
        value: '0',
        bh: '00300'
      }, {
        name: '晚加班',
        value: '1',
        bh: '00301'
      }, {
        name: '休息日加班',
        value: '2',
        bh: '00302'
      }, {
        name: '节假日加班',
        value: '3',
        bh: '00303'
      }],
      workType: [],
      tripId: '',
      //会议室编号
      startDate: '',
      //开始日期
      endDate: '',
      //截止日期
      kssj: this.$utils.Store.getItem('kssj') ? this.$utils.Store.getItem('kssj') : '',
      //开始时间
      jssj: this.$utils.Store.getItem('jssj') ? this.$utils.Store.getItem('jssj') : '',
      //结束时间
      minuteList: ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'],
      //定义分钟列表
      reason: this.$utils.Store.getItem('reason') ? this.$utils.Store.getItem('reason') : '',
      //外出目的
      inputParam: [{
        name: 'att_id',
        value: 0
      }, {
        name: 'base64String',
        value: ''
      }, {
        name: 'typeId',
        value: -1
      }],
      imgList: [],
      //图片列表数组
      limitNum: 5,
      //最多上传图片张数
      depSerial: this.$utils.Store.getItem('orgId'),
      //企业ID
      depName: this.$utils.Store.getItem('orgName'),
      //企业名称
      imgPath: [],
      //图片地址
      imgIndex: 0,
      //图片数组下标
      choose: this.$utils.Store.getItem('choose') ? this.$utils.Store.getItem('choose') : 0,
      //添加人员类型   1：审批人  2：抄送人  3：同行人
      icon: 'icon-jiahao',
      //icon加号
      //  ----以下是lwt的变量--2020-07-01
      approve: [],
      //要提交的审批节点列表
      allUserList: [],
      //获取过来的审批节点
      process: 0,
      //0简单审批 1条件审批
      userSerial: this.$utils.Store.getItem('userSerial'),
      //人员编号
      approveConditionId: '',
      approveSettingId: '',
      cc: {},
      //抄送人
      haveCC: false,
      //有没有抄送人
      showLevel: '',
      sbmitDis: true,
      //是否可以点击
      mealShow: false,
      //是否显示加班餐
      OvertimeMeals: this.$params.overtimeMeals,
      //是否显示加班餐
      mealList: [],
      //餐别列表
      acDepList: [],
      //餐厅列表
      placeId: '',
      //餐厅id,
      mealType: [],
      acDepType: [],
      // mealTime:'',//就餐时间
      approveStatues: false,
      //控制提交状态isDisabled
      chaosongzhuangtai: false //控制提交状态isDisabled

    };
  },
  computed: {
    isDisabled: function isDisabled() {
      if (this.sbmitDis && this.kssj != '' && this.jssj != '' && this.reason != '' && this.workType.length > 0) {
        /**/
        return false;
      } else {
        return true;
      }
    },
    mealTime: function mealTime() {
      if (this.mealType.length != 0 && this.acDepType.length != 0) {
        return this.mealList[this.mealType[0]].kssj + '-' + this.mealList[this.mealType[0]].jssj;
      }

      return null;
    }
  },
  watch: {
    workType: function workType(val) {
      var _this = this;

      if (typeof val == 'string') {
        this.workTypeList.some(function (item) {
          if (item.value == val) {
            _this.bh = item.bh;
          }
        });
      } else {
        this.workTypeList.some(function (item) {
          if (item.value == val[0]) {
            _this.bh = item.bh;
          }
        });
      }

      this.approve = [];
      this.getNodeList();
    }
  },
  methods: {
    /* 2021/11/15 优化增加删除不影响业务*/
    getShenpiRenshu: function getShenpiRenshu(aa) {
      /* 审批人数关联提交状态子组建传值 */
      if (aa > 0) {
        this.approveStatues = true;
      } else if (aa == 0) {
        this.approveStatues = false;
      }
    },

    /* 2021/11/15 优化增加删除不影响业务*/
    gechaosongrenshu: function gechaosongrenshu(aa) {
      /*抄送人数关联提交状态子组建传值 */
      if (aa > 0) {
        this.chaosongzhuangtai = true;
      } else if (aa == 0) {
        this.chaosongzhuangtai = false;
      }
    },

    /** function 获取服务器时间---今日日期
     *   wzx
     *   2019-01-11
     **/
    getSysDate: function getSysDate() {
      var _this2 = this;

      this.$utils.Tools.loadShow();
      this.$api.Sys.getSystemDate(this.$params.mode).then(function (response) {
        _this2.$utils.Tools.loadHide();

        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this2.$code.success) {
          Toast(msg);
        } else {
          _this2.startDate = data.sysDate.substring(0, 10);
          _this2.kssj = data.sysDate.substring(0, 16);
          _this2.jssj = _this2.dateEnd(_this2.kssj);
        }
      }).catch(function () {
        _this2.$utils.Tools.httpError();
      });
    },

    /** function 获取目的地
     *   wzx
     *   2019-01-07
     **/
    changeWorkType: function changeWorkType(val) {
      this.workType = val;
      this.acDepType = val;
      this.$utils.Store.setItem('workType', JSON.stringify(val));
    },

    /** function 获取外出开始时间
     *   wzx
     *   2019-01-05
     **/
    changeStartTime: function changeStartTime(val) {
      this.kssj = val;
      this.$utils.Store.setItem('kssj', val);
      this.startDate = val.substring(0, 10);

      if (this.OvertimeMeals == 1) {
        var hours = this.$utils.DateUtils.twoTimeInterval(val, this.jssj);

        if (hours >= 2) {
          this.mealShow = true;
        } else {
          this.mealShow = false;
          this.mealType = [];
        }
      }
    },

    /** function 获取外出结束时间
     *   wzx
     *   2019-01-05
     **/
    changeEndTime: function changeEndTime(val) {
      this.jssj = val;
      this.$utils.Store.setItem('jssj', val);
      this.endDate = val.substring(0, 10);

      if (this.OvertimeMeals == 1) {
        var hours = this.$utils.DateUtils.twoTimeInterval(this.kssj, val);

        if (hours >= 2) {
          this.mealShow = true;
        } else {
          this.mealShow = false;
          this.mealType = [];
        }
      }
    },

    /** function 获取选择的餐别
     *   lwt
     *   2020-10-21
     **/
    changeMeal: function changeMeal(val) {
      this.mealType = val;
    },

    /** function 获取选择的餐厅
     *   lwt
     *   2020-10-21
     **/
    changeacDep: function changeacDep(val) {
      this.acDepType = val;
    },

    /** function 获取外出事由
     *   wzx
     *   2019-01-05
     **/
    getReason: function getReason(val) {
      this.reason = val;
      this.$utils.Store.setItem('reason', val);
    },
    onChange: function onChange() {},
    onShow: function onShow() {},
    onHide: function onHide() {},

    /** function 提交加班申请
     *   wzx
     *   2019-01-05
     * */
    submitClick: function submitClick() {
      var _this3 = this;

      //  return;
      if (this.kssj > this.jssj) {
        Toast('开始时间不能大于结束时间');
      } else if (this.kssj == this.jssj) {
        Toast('开始时间不能与结束时间相同');
      } else if (this.ergArray(this.approve)) {
        Toast('未选择审批人');
        return;
      } else if (this.haveCC && !this.cc.userSerial[0]) {
        Toast('未选择抄送人');
        return;
      } else {
        this.imgPath = [];
        this.sbmitDis = false;
        var workType = JSON.stringify(this.workType).replace(/\[|]|"/g, '');

        var _iterator = _createForOfIteratorHelper(this.imgList),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var imgs = _step.value;
            this.imgPath.push(imgs.serverId);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        var imgPath = JSON.stringify(this.imgPath).replace(/\[|]|"/g, '');
        this.$utils.Tools.loadShow();
        var businessEntity = {
          bh: this.bh,
          bz: this.reason,
          imgPath: imgPath,
          kssj: this.kssj,
          jssj: this.jssj,
          jblx: workType,
          processId: '',
          qjlx: 1,
          userSerial: this.$utils.Store.getItem('userSerial')
        };
        var params = {
          businessEntity: businessEntity,
          approveCode: this.$params.overtimeMeals == 0 ? 3 : 7,
          approveSettingId: this.approveSettingId,
          approveConditionId: this.approveConditionId,
          approveCodeSub: this.bh,
          petitioner: this.$utils.Store.getItem('userSerial'),
          cc: [this.cc],
          showLevel: this.showLevel,
          approve: this.approve
        };

        if (this.$params.overtimeMeals == 0) {
          this.$api.Appr.apply(params).then(function (response) {
            _this3.$utils.Tools.loadHide();

            var code = response.code,
                msg = response.msg;
            _this3.sbmitDis = true;

            if (code == '625' || code == '626') {
              _this3.$utils.Tools.loadHide();

              Dialog.alert({
                title: '提示',
                message: msg,
                messageAlign: 'left',
                width: '70%',
                closeOnPopstate: true
              }).then(function () {
                // on close
                _this3.$router.go(0);
              });
              return;
            }

            if (+code !== _this3.$code.success) {
              Toast(msg);
            } else {
              Toast('提交成功');

              _this3.$router.go(-1); // this.$router.replace('/MyApply')

            }
          }).catch(function () {
            _this3.$utils.Tools.httpError();
          });
        } else {
          //  新增的一汽富维的接口  只加班
          var mealnow = this.mealList[this.mealType[0]];

          if (mealnow) {
            params.businessEntity.placeId = this.acDepType[0];
            params.businessEntity.mealName = mealnow.name;
            params.businessEntity.timeNo = mealnow.timeNo;
            params.businessEntity.mealKssj = mealnow.kssj;
            params.businessEntity.mealJssj = mealnow.jssj;
          }

          this.$api.Appr.outtimeapply(params).then(function (response) {
            _this3.$utils.Tools.loadHide();

            var code = response.code,
                msg = response.msg;
            _this3.sbmitDis = true;

            if (code == '625' || code == '626') {
              _this3.$utils.Tools.loadHide();

              Dialog.alert({
                title: '提示',
                message: msg,
                messageAlign: 'left',
                width: '70%',
                closeOnPopstate: true
              }).then(function () {
                // on close
                _this3.$router.go(0);
              });
              return;
            }

            if (+code !== _this3.$code.success) {
              Toast(msg);
            } else {
              Toast('提交成功');

              _this3.$router.go(-1); // this.$router.replace('/MyApply')

            }
          }).catch(function () {
            _this3.$utils.Tools.httpError();
          });
        }
      }
    },

    /** 函数function 设定当前页面
     *  wzx
     *  2019.01.09
     **/
    pushHistory: function pushHistory() {
      var state = {
        title: 'title',
        url: ''
      };
      window.history.pushState(state, state.title, state.url);
    },

    /** function 当前提交审批节点中是否有对应的节点
     *   lwt
     *   2020-07-03
     * */
    inspectObj: function inspectObj(sub) {
      var index = 0;
      var flag = this.approve.some(function (items, i) {
        if (items.level == sub.level) {
          index = i;
          return true;
        }
      });
      return {
        index: index,
        flag: flag
      };
    },

    /** function 获取子集的节点对象
     *   lwt
     *   2020-07-03
     * */
    getSubUserObj: function getSubUserObj(appr) {
      if (appr.cc && appr.cc == 1) {
        this.cc = appr;
        return;
      }

      if (this.approve.length == 0) {
        this.approve.push(appr);
      } else {
        var insUser = this.inspectObj(appr);

        if (insUser.flag) {
          //如果有重复的
          this.approve[insUser.index] = appr;
        } else {
          //没有重复的
          this.approve.push(appr);
        }
      }
    },

    /** function 遍历数组是否少
     *   wzx
     *  2020-0706
     **/
    ergArray: function ergArray(list) {
      if (!list) {
        return true;
      }

      var uindex = list.findIndex(function (item) {
        return !item.userSerial[0];
      });
      return uindex != -1;
    },
    // ----判断什么方式获取审批节点
    changeget: function changeget() {
      var _this4 = this;

      this.allUserList = [];
      this.leaveList.some(function (item) {
        if (_this4.bh == item.value && item.process == 0) {
          _this4.getNodeList();

          return true;
        } else if (_this4.bh == item.value && item.process == 1) {
          if (_this4.startDate && _this4.endDate) {
            _this4.getNodeList();

            return true;
          }
        }
      });
    },

    /** function 获取可审批的节点
     *   lwt
     *   2020-07-04
     * */
    getNodeList: function getNodeList() {
      var _this5 = this;

      this.$utils.Tools.loadShow();
      this.allUserList = [];
      this.haveCC = false;
      this.cc = {};
      var params = {
        approveCode: this.$params.overtimeMeals == 0 ? '3' : '7',
        //请假
        subCode: this.bh,
        startTime: this.kssj,
        //开始时间
        endTime: this.jssj,
        //结束时间
        userSerial: this.userSerial //人员序列

      };

      if (this.$params.overtimeMeals == 0) {
        this.$api.Appr.getApplicants(params).then(function (response) {
          var code = response.code,
              msg = response.msg,
              data = response.data;

          if (code == '602') {
            _this5.$utils.Tools.loadHide();

            Dialog({
              title: '提示',
              message: msg,
              messageAlign: 'left',
              width: '70%',
              closeOnPopstate: true
            });
            return;
          }

          if (+code !== _this5.$code.success) {
            _this5.$utils.Tools.loadHide();

            Toast(msg);
          } else {
            _this5.$utils.Tools.loadHide();

            _this5.showLevel = data.showLevel;

            if (data.showLevel == '1') {
              _this5.allUserList = data.approve;
            } else {
              for (var i = 0; i < data.approve.length; i++) {
                if (data.approve[i].level < data.showLevel) {
                  (function () {
                    var userItem = {};
                    var user = [];
                    data.approve[i].user.some(function (sub) {
                      user.push(sub.userSerial);
                    });
                    userItem.level = data.approve[i].level;
                    userItem.way = data.approve[i].levelWay;
                    userItem.levelId = data.approve[i].levelId;
                    userItem.userSerial = user;

                    _this5.approve.push(userItem);
                  })();
                } else {
                  _this5.allUserList.push(data.approve[i]);
                }
              }
            }

            if (data.ccSet) {
              _this5.haveCC = true;
              _this5.allUserList[_this5.allUserList.length] = data.ccSet; //抄送
            }

            _this5.approveConditionId = data.approveConditionId;
            _this5.approveSettingId = data.approveSettingId;
            _this5.process = data.process;
          }
        }).catch(function () {
          _this5.$utils.Tools.httpError();
        });
      } else {
        // 这是一汽富维的加班接口----定制的。
        this.$api.Appr.getApplicantsDealy(params).then(function (response) {
          var code = response.code,
              msg = response.msg,
              data = response.data;

          if (code == '602') {
            _this5.$utils.Tools.loadHide();

            Dialog({
              title: '提示',
              message: msg,
              messageAlign: 'left',
              width: '70%',
              closeOnPopstate: true
            });
            return;
          }

          if (+code !== _this5.$code.success) {
            _this5.$utils.Tools.loadHide();

            Toast(msg);
          } else {
            _this5.$utils.Tools.loadHide();

            _this5.showLevel = data.showLevel;
            _this5.mealList = [];
            _this5.acDepList = [];
            data.mealList.some(function (item, i) {
              item.name = item.lname;
              item.value = i + '';

              _this5.mealList.push(item);
            });
            data.acDepList.some(function (item) {
              item.name = item.depName;
              item.value = item.depSerial + '';

              _this5.acDepList.push(item);
            });

            if (data.showLevel == '1') {
              _this5.allUserList = data.approve;
            } else {
              for (var i = 0; i < data.approve.length; i++) {
                if (data.approve[i].level < data.showLevel) {
                  (function () {
                    var userItem = {};
                    var user = [];
                    data.approve[i].user.some(function (sub) {
                      user.push(sub.userSerial);
                    });
                    userItem.level = data.approve[i].level;
                    userItem.way = data.approve[i].levelWay;
                    userItem.levelId = data.approve[i].levelId;
                    userItem.userSerial = user;

                    _this5.approve.push(userItem);
                  })();
                } else {
                  _this5.allUserList.push(data.approve[i]);
                }
              }
            }

            if (data.ccSet) {
              _this5.haveCC = true;
              _this5.allUserList[_this5.allUserList.length] = data.ccSet; //抄送
            }

            _this5.approveConditionId = data.approveConditionId;
            _this5.approveSettingId = data.approveSettingId;
            _this5.process = data.process;
          }
        }).catch(function () {
          _this5.$utils.Tools.httpError();
        });
      }
    },

    /** function 开始时间后一个小时
     *   lwt
     *  2020-07-14
     **/
    dateEnd: function dateEnd(val) {
      var atime = val.replace(/-/g, '/');
      var now = new Date(atime);
      var time = now.getTime() + 1000 * 60 * 60;
      var dd = new Date(time); // let dd = new Date()

      var seperator1 = '-';
      var seperator2 = ':'; //   dd.setDate(dd.getDate() + AddDayCount) //获取AddDayCount天后的日期

      var y = dd.getFullYear();
      var m = dd.getMonth() + 1; //获取当前月份的日期

      var d = dd.getDate();
      var h = dd.getHours();
      var mm = dd.getMinutes();
      m = m > 9 ? m : '0' + m; //格式化时间

      d = d > 9 ? d : '0' + d;
      h = h > 9 ? h : '0' + h;
      mm = mm > 9 ? mm : '0' + mm;
      return y + seperator1 + m + seperator1 + d + ' ' + h + seperator2 + mm;
    }
  },
  created: function created() {
    // this.$utils.Store.removeItem('oldVal')
    this.getSysDate();

    if (this.$params.overtimeMeals == 1) {
      this.workTypeList = [{
        name: '工作日延时',
        value: '5',
        bh: '00306'
      }, {
        name: '休息日加班',
        value: '4',
        bh: '00305'
      }, {
        name: '节假日加班',
        value: '6',
        bh: '00307'
      }];
    }

    this.workType = [this.workTypeList[0].value + ''];
    this.bh = this.workTypeList[0].bh;
    this.getNodeList();
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {// this.$utils.Store.removeItem('oldVal')
  }
};